import React, { Fragment } from "react";
import CartLanding from "../components/CartLanding";
import Navbar from "../components/Navbar";

const Cart = () => {
  return (
    <Fragment>
      <div className="bg-cream h-full px-8 py-12 md:px-16 md:py-24">
        <Navbar />
        <CartLanding />
      </div>
    </Fragment>
  );
};

export default Cart;
